import { state, } from './constTypes';
export function flatten(withDetail = false) {
    const buffer = [];
    _flatten(state.root, buffer, withDetail ? { depth: -2, isLastChild: false, isNode: true } : undefined);
    return buffer;
}
function _flatten(entry, buffer, info) {
    if (isNode(entry)) {
        if (!isRoot(entry)) {
            buffer.push({
                timestamp: entry.timestamp,
                label: entry.label,
                depth: info ? info.depth + 1 : undefined,
                isLastChild: info === null || info === void 0 ? void 0 : info.isLastChild,
                isNode: info === null || info === void 0 ? void 0 : info.isNode,
            });
        }
        entry.children.forEach((child, i) => _flatten(child, buffer, info
            ? {
                depth: info.depth + 2,
                isLastChild: i === entry.children.length - 1,
                isNode: isNode(child),
            }
            : undefined));
    }
    else {
        buffer.push({
            timestamp: entry.timestamp,
            label: entry.label,
            data: entry.data,
            depth: info ? info.depth : undefined,
            isLastChild: info ? info.isLastChild : undefined,
            isNode: info === null || info === void 0 ? void 0 : info.isNode,
        });
    }
}
function isNode(item) {
    return 'parent' in item || item === state.root;
}
function isRoot(item) {
    return item === state.root;
}
export function toArray() {
    const buffer = [];
    state.root.children.forEach((child) => _toArray(child, buffer));
    return buffer;
}
function _toArray(logItem, buffer) {
    const entry = {
        timestamp: logItem.timestamp,
        label: logItem.label,
        data: isNode(logItem) ? undefined : logItem.data,
    };
    buffer.push(entry);
    if (isNode(logItem)) {
        const childBuffer = [];
        entry.children = childBuffer;
        logItem.children.forEach((child) => _toArray(child, childBuffer));
    }
}
//# sourceMappingURL=write.js.map